import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PlayerComponent } from "./player/player.component";
import { PlayerService } from "../core/services/player/player.service";
import { PlayerSeekComponent } from "./player-seek/player-seek.component";
import { PlayerControlsComponent } from "./player-controls/player-controls.component";
import { NgxBootstrapSliderModule } from "ngx-bootstrap-slider";
import { ArchiveModule } from "../archive/archive.module";
import { NgxLinkifyjsModule } from "ngx-linkifyjs";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [PlayerComponent, PlayerSeekComponent, PlayerControlsComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgxBootstrapSliderModule,
    ArchiveModule,
    NgxLinkifyjsModule,
    RouterModule,
  ],
  exports: [PlayerComponent],
  providers: [PlayerService],
})
export class PlayerModule {}
